import { Separator } from "@fluentui/react";
import AutoComplete from "components/controls/AutoComplete";
import Costshare from "components/controls/Costshare";
import LookupControl from "components/controls/LookupControl";

const Stencil = () => {

//     const testFetch = `
// <fetch version="1.0" output-format="xml-platform" mapping="logical" distinct="false">
//     <entity name="bcbs_bccadmin">
//         <attribute name="bcbs_bccadminid"/>
//         <attribute name="bcbs_name"/>
//         <attribute name="bcbs_code"/>
//         <attribute name="bcbs_fundingtypescode"/>
//         <attribute name="bcbs_description"/>
//         <attribute name="bcbs_ratetype"/>
//         <attribute name="bcbs_ratetypename"/>
//         <order attribute="bcbs_name" descending="false"/>
//         <filter type="and">
//             <condition attribute="statecode" operator="eq" value="0"/>
//         </filter>
//     </entity>
// </fetch>

// `


    return <div>
        <Costshare />
        <Separator />
        <AutoComplete />
        <Separator />
        <LookupControl
        label="BCC Admin"
        />

    </div>

}

export default Stencil;